import React, { useEffect } from 'react';
import {
    selectResources,
    selectContactDateTimeOption,
    selectContactTime,
    selectContactDate,
    selectContactOption,
    selectOpenTimesEndpoint,
    selectOpeningTimes
} from '../store/selectors';
import { connect } from 'react-redux';
import { RadioControlGroup, RadioInput, SelectField } from 'migration-flos-react';
import { setContactDateTimeOption, setContactTimeAction, setContactDateAction } from '../store/actions';
import DateField from '../components/date-field';
import { getOpenDates, getOpenTime } from '../lib';
import { fetchOpeningTimeAction } from '../store/form-actions';

const ContactTime = ({
    resources,
    contactDateTime,
    setContactDateTime,
    setContactTime,
    contactTime,
    contactDate,
    setContactDate,
    contactOption,
    fetchOpeningTime,
    openTimesObj
}) => {
    useEffect(() => {
        async function fetchTime() {
            await fetchOpeningTime();
        }
        fetchTime();
    }, [fetchOpeningTime]);

    const { section4 } = resources;
    const openTimes = getOpenTime(contactDate, openTimesObj, section4.time.default);
    const openDates = React.useMemo(() => getOpenDates(openTimesObj), [openTimesObj]);

    return (
        <div className="u-Space-up">
            <h3>{section4.title}</h3>
            <RadioControlGroup vertical={false} value={contactDateTime} onChangeValue={setContactDateTime}>
                <RadioInput id="option1" value="0" label={section4.option1} />
                <RadioInput id="option2" value="1" label={section4.option2} />
            </RadioControlGroup>
            {contactDateTime === '1' ? (
                <div className="row row--narrow">
                    {contactOption === 'PHONE' ? (
                        <div className="pull-left col-xs-12 col-lg-4">
                            <SelectField
                                id="contactPhoneDate"
                                label={section4.date.weekday}
                                options={openDates}
                                onChangeValue={setContactDate}
                                value={contactDate}
                            />
                        </div>
                    ) : (
                        <div className="pull-left col-xs-12 col-lg-2">
                            <DateField />
                        </div>
                    )}
                    <div className="col-lg-2 col-xs-12">
                        <SelectField
                            id="contactTime"
                            label={section4.time.label}
                            options={openTimes}
                            onChangeValue={setContactTime}
                            value={contactTime}
                        />
                    </div>
                </div>
            ) : null}
        </div>
    );
};

const mapStates = (state) => ({
    resources: selectResources(state),
    contactDateTime: selectContactDateTimeOption(state),
    contactTime: selectContactTime(state),
    contactDate: selectContactDate(state),
    contactOption: selectContactOption(state),
    openTimesEndpoint: selectOpenTimesEndpoint(state),
    openTimesObj: selectOpeningTimes(state)
});

const mapDispatch = (dispatch) => ({
    setContactDateTime: (dateTime) => {
        dispatch(setContactDateTimeOption(dateTime));
        if (dateTime === '0') {
            dispatch(setContactTimeAction(''));
            dispatch(setContactDateAction(''));
        } else if (dateTime === '1') {
            dispatch(setContactTimeAction(''));
            dispatch(setContactDateAction(getOpenDates()[0].value));
        }
    },
    setContactTime: (time) => dispatch(setContactTimeAction(time)),
    setContactDate: (date) => dispatch(setContactDateAction(date)),
    fetchOpeningTime: () => dispatch(fetchOpeningTimeAction())
});

export default connect(mapStates, mapDispatch)(ContactTime);
